import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { heroHighlights } from '../../data/content';
import { MOCKUP_ALT, MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section className="bg-brand-paper px-5 pb-12 pt-10 lg:px-8 lg:pb-16 lg:pt-14" data-id="element-104" data-mp="12ly0qm9iv2wg">
      <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="12k4wteqamws5">
        <p className="font-body text-[11px] font-bold uppercase tracking-[0.18em] text-brand-pink sm:text-[12px]" data-id="element-106" data-mp="1zaxdadh52qug">
          For PMU Instructors, Trainers &amp; Academy Owners
        </p>

        <h1 className="mt-4 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-107" data-mp="1qahc5anvbvsr">
          PMU Instructors: Get Your Classes Ready in <Accent data-id="element-108" data-mp="exeusddy327j">Minutes — Not Hours!</Accent>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl font-body text-[16px] font-medium leading-relaxed text-brand-charcoal/80 sm:text-[18px]" data-id="element-109" data-mp="9xacqixe1zf7">
          Stop spending your evenings creating lesson plans, student worksheets, and assessments from scratch.
        </p>
      </div>

      <img src={MOCKUP_URL} alt={MOCKUP_ALT} width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-8 block aspect-[3/2] w-full max-w-[640px] object-contain lg:max-w-[920px]" style={{
      filter: 'drop-shadow(0 34px 40px rgba(120, 90, 60, 0.2))'
    }} data-id="element-110" data-mp="3demqeziyrkmm" />

      <div className="mx-auto mt-8 max-w-2xl space-y-3 text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-111" data-mp="2uh3ftrguxty3">
        <p className="font-semibold text-brand-charcoal" data-id="element-112" data-mp="2gqgdzqfsvnxs">
          Everything you need to organize your PMU classes — in one ready-to-use teaching system.
        </p>
        <p data-id="element-113" data-mp="26qfvu7to3dv6">
          From brow mapping and pigment theory to student practice, lesson planning, and assessments, PMU Instructor
          Ready™ helps you spend less time preparing materials and more time teaching.
        </p>
      </div>

      <ul role="list" className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2.5 font-body text-[13px] font-semibold text-brand-charcoal sm:text-[14px]" data-id="element-114" data-mp="hbev1ngpyk5y">
        {heroHighlights.map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-115" data-mp="3iff5kd0ynxv">
            <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-116" data-mp="3ka2f5brqs54" />
            {item}
          </li>)}
      </ul>

      <CtaBlock label="Get my PMU teaching system" className="mt-8" data-id="element-117" data-mp="w6uvca7w7cas" />
    </section>;
}